import React, { useContext, useEffect, useState } from 'react';
import styles from './AddCategoryForm.module.scss';
import { Select } from 'esa-ui-library';
import { Form } from '../../../components';
import { useStore } from '../../../../common';
import { PropertyType } from 'esa-ui-library/lib/types';
import { AuthContext } from '../../../../logic';

const AddCategoryForm = (): JSX.Element => {
	const [state, dispatch] = useStore();
	const [isLoading, setIsLoading] = useState(true);
	const { token } = useContext(AuthContext);
	const { success, gameCategories, categoryForm, selectedGame } = state;

	const onSelect = (val: PropertyType[]) => {
		dispatch('FORM_CATEGORY', { categories: val });
	};

	const getGame = async () => {
		setIsLoading(true);
		await dispatch('GAME_INIT', { token, id: selectedGame.internal_game_id });
		setIsLoading(false);
	};

	useEffect(() => {
		if (selectedGame) {
			getGame();
		}
	}, [selectedGame]);

	return (
		<section className={isLoading ? styles.DisableForm : ''}>
			<Form success={success}>
				<div>
					<Select
						className={styles.Input}
						label='Game category'
						removeable
						options={gameCategories}
						multiple
						required
						placeholder='Select category'
						selected={categoryForm.categories}
						dataId='category-field'
						onChange={(val) => onSelect(val)}
					/>
				</div>
			</Form>
		</section>
	);
};

export { AddCategoryForm };
